/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filecategoryinvoice2Inputs */

const en_filecategoryinvoice2 = /** @type {(inputs: Filecategoryinvoice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice`)
};

const pt_filecategoryinvoice2 = /** @type {(inputs: Filecategoryinvoice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatura`)
};

/**
* | output |
* | --- |
* | "Invoice" |
*
* @param {Filecategoryinvoice2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filecategoryinvoice2 = /** @type {((inputs?: Filecategoryinvoice2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filecategoryinvoice2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filecategoryinvoice2(inputs)
	return pt_filecategoryinvoice2(inputs)
});
export { filecategoryinvoice2 as "fileCategoryInvoice" }